// Store
import store from 'tricks/browser/agent/localStorage.js';
import {USER_PREFERENCE_KEYS} from './constants';

store.clear = function () {
	try {
		const userPreferences = saveUserPrefs();

		window.localStorage.clear();

		restoreUserPrefs(userPreferences);
	} catch {
		// continue
	}
};

function saveUserPrefs() {
	const restorableUserPrefs = {};
	Object.values(USER_PREFERENCE_KEYS).forEach(key => {
		const value = store(key);
		if (value) {
			restorableUserPrefs[key] = value;
		}
	});
	return restorableUserPrefs;
}

function restoreUserPrefs(restorableUserPrefs) {
	store(restorableUserPrefs);
}

export default store;
